import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [      // random text
  {
    title: 'Improving end distrusts instantly',
    text: 'From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded.',
  },
  {
    title: 'Become the tended active',
    text: 'Considered sympathize ten uncommonly occasional assistance sufficient not. Letter of on become he tended active enable to.',
  },
  {
    title: 'Message or am nothing',
    text: 'Led ask possible mistress relation elegance eat likewise debating. By message or am nothing amongst chiefly address.',
  },
  {
    title: 'Really boy law county',
    text: 'Really boy law county she unable her sister. Feet you off its like like six. Among them are leave law built now...',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradiant__text">L'avenir est maintenant et vous avez juste besoin de le réaliser. Entrez dans l'avenir
       dès aujourd'hui et faites-en une réalité.</h1>
      <p>Demander un accès anticipé pour commencer</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (      //loop sur une Array d'obj
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;